import { render } from "./LightingTest.vue?vue&type=template&id=ecca62c8&scoped=true"
import script from "./LightingTest.vue?vue&type=script&lang=js"
export * from "./LightingTest.vue?vue&type=script&lang=js"

import "./LightingTest.vue?vue&type=style&index=0&id=ecca62c8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecca62c8"]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox,QInnerLoading});
